import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "spinner-border spinner-border-lg",
    role: "status",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "border-bottom pb-2 mb-4" }, "Criar Transmissão")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12 mt-2 mb-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Selecione o número origem", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-12 mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Nome", -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "col-12 mt-2 mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Mensagem", -1)
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "col-12 mt-2 border-bottom pb-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-12 mb-1",
  for: "arquivo"
}, "Anexar Arquivo", -1)
const _hoisted_17 = { class: "col-12 mt-2 mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 2,
  class: "col-12 mt-2 input-group"
}
const _hoisted_21 = { class: "input-group-append" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "input-group-append" }
const _hoisted_24 = {
  key: 3,
  class: "col-12"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", {
  id: "emailHelp",
  class: "form-text text-muted"
}, [
  /*#__PURE__*/_createTextVNode(" O arquivo csv deve estar no layout ["),
  /*#__PURE__*/_createElementVNode("b", null, "numero"),
  /*#__PURE__*/_createTextVNode(";"),
  /*#__PURE__*/_createElementVNode("b", null, "mensagem"),
  /*#__PURE__*/_createTextVNode(";"),
  /*#__PURE__*/_createElementVNode("b", null, "nome"),
  /*#__PURE__*/_createTextVNode("], sendo o nome não obrigatório ")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 4,
  class: "col-12 dests pt-2"
}
const _hoisted_28 = { class: "list-group" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "col-12 mt-4 pt-3 border-top" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-6 mt-2 pt-2 text-md-start" }
const _hoisted_33 = {
  key: 0,
  class: "col-6 mt-2 pt-2 text-md-end"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 1,
  class: "btn btn-info",
  disabled: ""
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "col-6 mt-2 pt-2 text-md-end"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 1,
  class: "btn btn-info",
  disabled: ""
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_42 = [
  _hoisted_41
]

import {onMounted, reactive, ref} from "vue";
import Papa from "papaparse"
import {MaskaDetail, vMaska} from "maska"
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faClock} from "@fortawesome/free-regular-svg-icons"
import {faCheck, faCheckDouble, faBan, faTimes, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import Destination from "@/models/Destination";
import {MessageStatusEnum} from "@/models/MessageStatusEnum";
import apiService from "@/services/api.service";
import transmissionService from "@/services/transmission.service";
import {useRoute, useRouter} from "vue-router";
import {AxiosResponse} from "axios";

interface Contact {
    phone_number: string;
    name: string;
  }



export default /*#__PURE__*/_defineComponent({
  __name: 'TransmissionsCreateShipment',
  setup(__props) {


const uploadExcel = ref<HTMLFormElement | null>(null);

const dests = ref<Destination[]>([]);
const contactInput = ref<HTMLInputElement | null>(null);
const body = ref('');
const name = ref('');

const contactValue = reactive({} as MaskaDetail);
const maskedValue = ref('');

const baseUrl = apiService.getBaseUrl();
const authHeader = apiService.getAuthHeader();
const isLoading = ref(false);
const isUploading = ref(false);
const attach = ref<HTMLInputElement | null>(null);
const uploadUrl = ref('');
const uploadFileName = ref('');
const route = useRoute();
const router = useRouter();
const id = parseInt(route.params.id as string);
const cloneId = parseInt(route.params.cloneId as string);

function addContact() {
  if (contactValue.unmasked) {
    dests.value.push({number: contactValue.unmasked, name: maskedValue.value});
    maskedValue.value = '';
    contactInput.value?.focus();
  }
}

function getIconByStatus(status: MessageStatusEnum) {
  console.log(status)
  switch (status) {
    case MessageStatusEnum.PENDING:
     return faClock;
    case MessageStatusEnum.FAIL:
    return faExclamationTriangle;
    case MessageStatusEnum.SENT:
      return faCheck;
    case MessageStatusEnum.DELIVERED:
    case MessageStatusEnum.READ:
      return faCheckDouble;
  }
}

function getNumberOnly(value: string) {
  return value.replace(/\D/g, '');
}

function clearNumber(value: string) {
  const numbers = getNumberOnly(value);
  return numbers
}

function handleFileUpload(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) return;
  uploadFileName.value = file.name;
  const size = (file.size / (1024 * 1024));
  if (size > 300) {
    alert('O arquivo deve ter no máximo 300mb');
    return false;
  }
  isUploading.value = true;
  transmissionService.uploadFile(file).then(function (res: AxiosResponse) {
    const {fileUrl} = res.data;
    uploadUrl.value = fileUrl;
  }).catch((error) => {
    console.log(error);
  }).finally(() => {
    isUploading.value = false;
  });
}

function save(){

  const data = {
    name: name.value,
    dests: dests.value,
    body: body.value,
    fileUrl: uploadUrl.value,
    fileName: uploadFileName.value,
    phoneNumber: selectedContact.value
  };

  isLoading.value = true;

  transmissionService.create(data).then((res) => {
    isLoading.value = false;
    router.replace({name: 'transmission', params: {id: res.data.id}}).then(() => {
      window.location.reload()
    });
  });

}

function handleCsv(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  console.time('csv')
  if (file) {
    const reader = new FileReader();
    console.time('file')
    reader.onload = function (e) {
      console.timeEnd('file')
      const csv = e.target?.result;
      if (csv) {
        Papa.parse(csv as never, {
          worker: true,
          delimiter: ';',
          complete: function (results: { data: string[][] }) {
            results.data.forEach((item: string[]) => {
              if (item.length === 0) return;
              const number = clearNumber(item[0]);
              if (dests.value.some(dest => dest.number === number)) return;
              if (number.length < 9) return;
              const message = item[1]?.trim();
              const name = item[2]?.trim();
              if (item.length > 0) {
                dests.value.push({number, message, name: name !== '' ? name : number});
              }
            });
            console.log(dests.value)
            console.timeEnd('csv')
          }
        })
      }
    }
    reader.readAsText(file);
  }
}

function getTransmission(){
  if (id || cloneId) {
    isLoading.value = true;
    transmissionService.getById(id || cloneId).then(response => {
      const data = response.data;
      body.value = data.body;
      name.value = data.name;
      uploadUrl.value = data.file_url;
      if (cloneId && !!data.file_url){
        const aux = data.file_url.split('/');
        uploadFileName.value = aux[aux.length - 1];
      }
      dests.value = data.messages.map((dest: any) => {
        return {
          number: dest.contact.number,
          name: dest.contact.name,
          messageStatus: cloneId ? undefined : parseInt(dest.wpp_message_status)
        }
      });
      isLoading.value = false;
    });
  }
}

onMounted(() => {
  getTransmission()
});

const contactsForSelect = ref<Contact[]>([]);
const selectedContact = ref<string>('');
console.log(selectedContact)

const getPhoneList = async () => {
  try {
    const response = await transmissionService.getPhoneList();
    contactsForSelect.value = response.data as Contact[];
  } catch (error) {
    console.error('Erro ao obter lista de contatos:', error);
  }
};

onMounted(() => {
  getPhoneList();
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(id) && isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedContact).value = $event)),
                class: "form-control"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactsForSelect.value, (contact) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: contact.phone_number,
                    value: contact.phone_number
                  }, _toDisplayString(contact.name) + " - " + _toDisplayString(contact.phone_number), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedContact.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
            type: "text",
            class: "form-control",
            placeholder: "Insira o nome da transmissão",
            disabled: !!_unref(id)
          }, null, 8, _hoisted_11), [
            [_vModelText, name.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("textarea", {
            disabled: !!_unref(id),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body).value = $event)),
            class: "form-control",
            rows: "3",
            placeholder: "Digite a mensagem ({{nome}} será substituido pelo nome do contato)"
          }, null, 8, _hoisted_14), [
            [_vModelText, body.value]
          ])
        ]),
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("input", {
                type: "file",
                class: "form-control file",
                id: "arquivo",
                ref_key: "attach",
                ref: attach,
                onChange: handleFileUpload
              }, null, 544)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          (isUploading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18))
            : _createCommentVNode("", true),
          (uploadUrl.value != '')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                target: "_blank",
                class: "mt-2",
                href: uploadUrl.value
              }, "Arquivo", 8, _hoisted_19))
            : _createCommentVNode("", true),
          (uploadUrl.value && !_unref(id))
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-danger btn-sm ml-1 mt-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (uploadUrl.value = ''))
              }, "X"))
            : _createCommentVNode("", true)
        ]),
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "contactInput",
                ref: contactInput,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((maskedValue).value = $event)),
                "data-maska": "(##) #####-####",
                type: "text",
                class: "form-control",
                onKeydown: _withKeys(addContact, ["enter"])
              }, null, 544), [
                [_vModelText, maskedValue.value],
                [_unref(vMaska), contactValue]
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "btn btn-info",
                  type: "button",
                  onClick: addContact,
                  disabled: contactValue.unmasked?.length <= 9
                }, "Adicionar", 8, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (uploadExcel.value?.click()))
                }, "Importar CSV"),
                _createElementVNode("input", {
                  type: "file",
                  id: "upload",
                  style: {"display":"none"},
                  ref_key: "uploadExcel",
                  ref: uploadExcel,
                  onChange: handleCsv
                }, null, 544)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
          : _createCommentVNode("", true),
        (!!dests.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (!_unref(id))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (dests.value = []), ["prevent"]))
                  }, "Limpar"))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dests.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.number,
                    class: _normalizeClass(["list-group-item d-flex justify-content-between align-items-center wpp-font-color", {'bg-danger': item.messageStatus === _unref(MessageStatusEnum).FAIL}])
                  }, [
                    _createTextVNode(_toDisplayString(item.name !== item.number ? item.number + ' - ' + item.name : item.number) + " ", 1),
                    (item.messageStatus !== undefined)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["badge badge-pill", item.messageStatus === _unref(MessageStatusEnum).READ ? 'read-message' : 'unread-message'])
                        }, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            icon: getIconByStatus(item.messageStatus ?? 0)
                          }, null, 8, ["icon"])
                        ], 2))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "#",
                          onClick: _withModifiers(($event: any) => (dests.value.splice(dests.value.indexOf(item), 1)), ["prevent"])
                        }, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            class: "text-danger",
                            icon: _unref(faBan)
                          }, null, 8, ["icon"])
                        ], 8, _hoisted_29))
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_router_link, {
                class: "btn btn-primary mr-2",
                to: {name: 'listTransmissions'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Voltar")
                ]),
                _: 1
              })
            ]),
            (!_unref(id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info",
                        onClick: save,
                        disabled: dests.value.length === 0 || body.value.length === 0 || isLoading.value || !selectedContact.value
                      }, " Salvar ", 8, _hoisted_34))
                    : (_openBlock(), _createElementBlock("button", _hoisted_35, _hoisted_37))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info",
                        onClick: getTransmission,
                        disabled: isLoading.value
                      }, " Atualizar ", 8, _hoisted_39))
                    : (_openBlock(), _createElementBlock("button", _hoisted_40, _hoisted_42))
                ]))
          ])
        ])
      ]))
}
}

})